module.exports = __webpack_public_path__ + "img/symbol_2.1ee8a377.png";